function contains(parentNode, childNode) {
  if (parentNode.contains) {
    return parentNode.contains(childNode);
  }
  return Boolean(parentNode.compareDocumentPosition(childNode) & 16);
}
export default contains;